import { lazy } from "react";

// ── Code-split admin pages too ─────────────────────────────────────────────
const Login = lazy(() => import("pages/Admin/Authentication/Login"));
const Resetpassword = lazy(
	() => import("pages/Admin/Authentication/Resetpassword"),
);
const ForgetPassword = lazy(
	() => import("pages/Admin/Authentication/ForgetPassword"),
);
const Logout = lazy(() => import("pages/Admin/Authentication/Logout"));
const Pages404 = lazy(() => import("pages/Utility/pages-404"));
const Pages500 = lazy(() => import("pages/Utility/pages-500"));
const AdminsPage = lazy(() => import("pages/Admin/Admins"));
const Bookings = lazy(() => import("pages/Admin/Bookings"));
const Devices = lazy(() => import("pages/Admin/Devices"));
const CreateRolePage = lazy(() => import("pages/Admin/Admins/CreateRole"));
const Games = lazy(() => import("pages/Admin/Games"));
const Coupons = lazy(() => import("pages/Admin/Coupons"));
const Settings = lazy(() => import("pages/Admin/Settings"));
const Pricings = lazy(() => import("pages/Admin/Pricings"));
const Packages = lazy(() => import("pages/Admin/Packages"));
const Users = lazy(() => import("pages/Admin/Users"));

const adminRoutes = [
	{ path: "/admins/roles-create", component: CreateRolePage, exact: true },
	{ path: "/admins/roles-edit/:id", component: CreateRolePage, exact: true },
	{ path: "/admins", component: AdminsPage, exact: true },
	{ path: "/bookings", component: Bookings, exact: true },
	{ path: "/games", component: Games, exact: true },
	{ path: "/devices", component: Devices, exact: true },
	{ path: "/coupons", component: Coupons, exact: true },
	{ path: "/pricings", component: Pricings, exact: true },
	{ path: "/packages", component: Packages, exact: true },
	{ path: "/users", component: Users, exact: true },
	{ path: "/settings", component: Settings, exact: true },
	{ path: "/logout", component: Logout, exact: true },
	{ path: "/pages-404", component: Pages404, exact: true },
];

const adminAuthRoutes = [
	{ path: "/login", component: Login, exact: true },
	{ path: "/forget-password", component: ForgetPassword, exact: true },
	{ path: "/reset-password", component: Resetpassword, exact: true },
	{ path: "/pages-500", component: Pages500, exact: true },
];

export { adminRoutes, adminAuthRoutes };
